import { Injectable, inject } from '@angular/core';

import { BehaviorSubject, catchError, throwError, lastValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class GlobalFiltersService {
	private leagueYear$ = new BehaviorSubject<{ leagueYearID: number, leagueYearName: string, isCurrent: boolean } | null>(null);

	getLeagueYearID() {
		return this.leagueYear$.getValue()?.leagueYearID || null;
	}
	getLeagueYearName() {
		return this.leagueYear$.getValue()?.leagueYearName || null;
	}
	getIsCurrentLeagueYear() {
		return this.leagueYear$.getValue()?.isCurrent || false;
	}

	getLeagueYear$() {
		return this.leagueYear$.asObservable();
	}
	getLeagueYear() {
		return this.leagueYear$.getValue();
	}

	setLeagueYear(leagueYearID: number, leagueYearName: string, isCurrent: boolean) {
		console.log('***Setting league year:', leagueYearID, leagueYearName, isCurrent);
		this.leagueYear$.next({ leagueYearID, leagueYearName, isCurrent });
	}
}
